import { motion } from "framer-motion";

export default function ChapterHeading({ num, title, note, testid }) {
  return (
    <div data-testid={testid} className="px-5 md:px-10 mb-16 md:mb-24">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="flex flex-col md:flex-row md:items-end gap-4 md:gap-10 border-b border-black/10 pb-8"
      >
        <span className="font-mono text-sm tracking-[0.3em] text-terra">{num} /</span>
        <h2 className="font-serif font-light uppercase text-[clamp(2rem,5.5vw,5.5rem)] leading-none tracking-tight">
          {title}
        </h2>
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-black/50 md:ml-auto md:pb-3">
          {note}
        </p>
      </motion.div>
    </div>
  );
}
